export const state = {
  kitTulles1Choosen: '',
  kitTulles2Choosen: '',
  kitTulles3Choosen: '',
  kitTulles4Choosen: '',
  kitTulles5Choosen: '',
  kitTulles6Choosen: '',
  costTulle1: null,
  costTulle2: null,
  costTulle3: null,
  costTulle4: null,
  costTulle5: null,
  costTulle6: null,
  tulles: [
    { title: 'Тюль', src: '/img/tulle.jpg' },
    { title: 'Тюль', src: '/img/tulle2.jpg' },
    { title: 'Рулонная штора', src: '/img/rul_white.jpg' },
    { title: 'Рулонная штора', src: '/img/rul_bej.jpg' },
    { title: 'Без тюля', src: '/img/nothing.jpg' }
  ]
}

export const getters = {

}

export const mutations = {
  updateTulles1 (state, kitTulles1Choosen) {
    state.kitTulles1Choosen = kitTulles1Choosen
  },
  updateTulles2 (state, kitTulles2Choosen) {
    state.kitTulles2Choosen = kitTulles2Choosen
  },
  updateTulles3 (state, kitTulles3Choosen) {
    state.kitTulles3Choosen = kitTulles3Choosen
  },
  updateTulles4 (state, kitTulles4Choosen) {
    state.kitTulles4Choosen = kitTulles4Choosen
  },
  updateTulles5 (state, kitTulles5Choosen) {
    state.kitTulles5Choosen = kitTulles5Choosen
  },
  updateTulles6 (state, kitTulles6Choosen) {
    state.kitTulles6Choosen = kitTulles6Choosen
  },
  updateCostTulle1 (state) {
    if (state.kitTulles1Choosen === 'Нет') {
      state.costTulle1 = null
    } else if (state.kitTulles1Choosen === 'Тюль, цвет: белый' || state.kitTulles1Choosen === 'Тюль, цвет: бежевый') {
      state.costTulle1 = 1990
    } else if (state.kitTulles1Choosen === 'Рулонная штора, цвет: белый' || state.kitTulles1Choosen === 'Рулонная штора, цвет: бежевый') {
      state.costTulle1 = 1990
    } else {
      state.costTulle1 = null
    }
  },
  updateCostStep4Tulle1 (state) {
    if (this.state.Window1.widthWindow1 >= 2500) {
      state.costTulle1 = 1990 + (1990 * 0.35)
    }
  },
  updateCostStep4Tulle1WithErker (state) {
    if (this.state.Window1.windowTypeSelected1 === 'Эркерное окно') {
      state.costTulle1 = state.costTulle1 + (state.costTulle1 * 0.35)
    }
  },
  // 2 окно
  updateCostTulle2 (state) {
    if (state.kitTulles2Choosen === 'Нет') {
      state.costTulle2 = null
    } else if (state.kitTulles2Choosen === 'Тюль, цвет: белый' || state.kitTulles2Choosen === 'Тюль, цвет: бежевый') {
      state.costTulle2 = 1990
    } else if (state.kitTulles2Choosen === 'Рулонная штора, цвет: белый' || state.kitTulles2Choosen === 'Рулонная штора, цвет: бежевый') {
      state.costTulle2 = 1990
    } else {
      state.costTulle2 = null
    }
  },
  updateCostStep4Tulle2 (state) {
    if (this.state.Window2.widthWindow2 >= 2500) {
      state.costTulle2 = 1990 + (1990 * 0.35)
    }
  },
  updateCostStep4Tulle2WithErker (state) {
    if (this.state.Window2.windowTypeSelected2 === 'Эркерное окно') {
      state.costTulle2 = state.costTulle2 + (state.costTulle2 * 0.35)
    }
  },
  // 3 окно
  updateCostTulle3 (state) {
    if (state.kitTulles3Choosen === 'Нет') {
      state.costTulle3 = null
    } else if (state.kitTulles3Choosen === 'Тюль, цвет: белый' || state.kitTulles3Choosen === 'Тюль, цвет: бежевый') {
      state.costTulle3 = 1990
    } else if (state.kitTulles3Choosen === 'Рулонная штора, цвет: белый' || state.kitTulles3Choosen === 'Рулонная штора, цвет: бежевый') {
      state.costTulle3 = 1990
    } else {
      state.costTulle3 = null
    }
  },
  updateCostStep4Tulle3 (state) {
    if (this.state.Window3.widthWindow3 >= 2500) {
      state.costTulle3 = 1990 + (1990 * 0.35)
    }
  },
  updateCostStep4Tulle3WithErker (state) {
    if (this.state.Window3.windowTypeSelected3 === 'Эркерное окно') {
      state.costTulle3 = state.costTulle3 + (state.costTulle3 * 0.35)
    }
  },
  // 4 окно
  updateCostTulle4 (state) {
    if (state.kitTulles4Choosen === 'Нет') {
      state.costTulle4 = null
    } else if (state.kitTulles4Choosen === 'Тюль, цвет: белый' || state.kitTulles4Choosen === 'Тюль, цвет: бежевый') {
      state.costTulle4 = 1990
    } else if (state.kitTulles4Choosen === 'Рулонная штора, цвет: белый' || state.kitTulles4Choosen === 'Рулонная штора, цвет: бежевый') {
      state.costTulle4 = 1990
    } else {
      state.costTulle4 = null
    }
  },
  updateCostStep4Tulle4 (state) {
    if (this.state.Window4.widthWindow4 >= 2500) {
      state.costTulle4 = 1990 + (1990 * 0.35)
    }
  },
  updateCostStep4Tulle4WithErker (state) {
    if (this.state.Window4.windowTypeSelected4 === 'Эркерное окно') {
      state.costTulle4 = state.costTulle4 + (state.costTulle4 * 0.35)
    }
  },
  // 5 окно
  updateCostTulle5 (state) {
    if (state.kitTulles5Choosen === 'Нет') {
      state.costTulle5 = null
    } else if (state.kitTulles5Choosen === 'Тюль, цвет: белый' || state.kitTulles5Choosen === 'Тюль, цвет: бежевый') {
      state.costTulle5 = 1990
    } else if (state.kitTulles5Choosen === 'Рулонная штора, цвет: белый' || state.kitTulles5Choosen === 'Рулонная штора, цвет: бежевый') {
      state.costTulle5 = 1990
    } else {
      state.costTulle5 = null
    }
  },
  updateCostStep4Tulle5 (state) {
    if (this.state.Window5.widthWindow5 >= 2500) {
      state.costTulle5 = 1990 + (1990 * 0.35)
    }
  },
  updateCostStep4Tulle5WithErker (state) {
    if (this.state.Window5.windowTypeSelected5 === 'Эркерное окно') {
      state.costTulle5 = state.costTulle5 + (state.costTulle5 * 0.35)
    }
  },
  // 6 окно
  updateCostTulle6 (state) {
    if (state.kitTulles6Choosen === 'Нет') {
      state.costTulle6 = null
    } else if (state.kitTulles6Choosen === 'Тюль, цвет: белый' || state.kitTulles6Choosen === 'Тюль, цвет: бежевый') {
      state.costTulle5 = 1990
    } else if (state.kitTulles6Choosen === 'Рулонная штора, цвет: белый' || state.kitTulles6Choosen === 'Рулонная штора, цвет: бежевый') {
      state.costTulle6 = 1990
    } else {
      state.costTulle6 = null
    }
  },
  updateCostStep4Tulle6 (state) {
    if (this.state.Window6.widthWindow6 >= 2500) {
      state.costTulle6 = 1990 + (1990 * 0.35)
    }
  },
  updateCostStep4Tulle6WithErker (state) {
    if (this.state.Window6.windowTypeSelected6 === 'Эркерное окно') {
      state.costTulle6 = state.costTulle6 + (state.costTulle6 * 0.35)
    }
  }
}

export const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
